// extracted by mini-css-extract-plugin
export default {"filename":"FormattedFileName_filename__FF8sn","inlineFilename":"FormattedFileName_inlineFilename__B0ChD","name":"FormattedFileName_name__AzGVu"};